import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import moment from "moment";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";

const getBoardVariableDataSerieValues = (boardId, elemenentId, dataserieId, calendarSelectorId, displayAgregationId, periodStartDate, periodEndsDate) => {
    //[##PATH ROUTE##]
    let qs_periodStartDate = periodStartDate !== null && periodStartDate !== undefined ? `period_start_date=${periodStartDate}` : '';
    let qs_periodEndsDate = periodEndsDate !== null && periodEndsDate !== undefined ? `period_ends_date=${periodEndsDate}` : '';

    displayAgregationId = displayAgregationId === true ? 2 : (displayAgregationId === false ? 1 : displayAgregationId)

    let url = `/api/Board/boardelementdataseriesvalues/${boardId}/${elemenentId}/${isNullUndefinedOrEmpty(dataserieId) ? 0 : dataserieId}/${calendarSelectorId}/${displayAgregationId}/list`
 
    if(qs_periodStartDate !== '' )
    {
        url = url + '?' + qs_periodStartDate
    }
    if(qs_periodEndsDate !== '')
    {
        if(qs_periodStartDate != '' )
        {
            url = url + '&' + qs_periodEndsDate
        }
        else
        {
            url = url + '?' + qs_periodEndsDate		
        }
    }

    return axios.get(url, { headers: authHeaderJson() })
};

const getDataSerieValue = (dataserieId, dataserieValueId, serieTime) => {
    //[##PATH ROUTE##]
    let qs_serieTime = serieTime !== null ? `?serie_time=${serieTime}` : '';
    return axios.get(`/api/SkVariable/dataserie/${dataserieId}/${isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId}${qs_serieTime}`, { headers: authHeaderJson() })
};

const getDataserieElementTag = (dataserieId) => {
    return axios.get(`/api/SkVariable/dataserie/tag/${dataserieId}`, { headers: authHeaderJson() })
};


const addDataserieElementTags = (objectToSave) => {
    return axios({ method: 'post', url: `/api/SkVariable/dataserie/tag`, headers: authHeaderJson(), data : objectToSave })
};

const postDataserieValueCloseProcess = (elementId, closeProcess, start_date, end_date, objDataserieSelectedList) => {
    const request = {l_dataserie_id: objDataserieSelectedList, closeProcess, element_id: elementId, start_date, end_date}
    return axios({ method: 'post', url: `/api/SkVariable/daserievaluecloseprocess/${elementId}`, headers: authHeaderJson(), data : request })
};

const postDataserieValueLocked = (elementId, dataserieValueId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/SkVariable/dataserievaluelocked/${elementId}/${dataserieValueId}`, { headers: authHeaderJson() });
};

const addVariableDataserieToElement = (elementId, dataserieList) => {
    return axios({ method: 'post', url: `/api/SkVariable/dataserie/${elementId}/list`, headers: authHeaderJson(), data : JSON.stringify(dataserieList) })
};

const deleteVariableDataserieFromElement = (dataserieId) => {
    return axios.delete(`/api/SkVariable/dataserie/${ dataserieId }`, { headers: authHeaderJson() });
};

const addDataSerieValue = (objDataSerie) => {
    return axios({ method: 'post', url: `/api/SkVariable/dataserievalue`, headers: authHeaderJson(), data : JSON.stringify(objDataSerie) })
};

const editDataSerieValue = (objDataSerie) => {
    return axios.put(`/api/SkVariable/dataserievalue/${objDataSerie.id}`, objDataSerie, { headers: authHeaderJson() });
};

const refreshDataSerieValue = (id) => {
    //[##]PROBAR
    return axios.put(`/api/SkVariable/dataserievalue/refresh/${id}`, { headers: authHeaderJson() });
};

const updateDataserie = (dataSerieId, objDataSerie) => {
    return axios.put(`/api/SkVariable/dataserie/${dataSerieId}`, objDataSerie, { headers: authHeaderJson() });
};

export {
    getDataSerieValue,
    getDataserieElementTag,
    addDataserieElementTags,
    getBoardVariableDataSerieValues,
    addDataSerieValue,
    editDataSerieValue,
    updateDataserie,
    addVariableDataserieToElement,
    deleteVariableDataserieFromElement,
    postDataserieValueCloseProcess,
    postDataserieValueLocked
}